module.exports = __webpack_public_path__ + "static/media/log.af74d5dc.PNG";